import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { BonusPobjednici } from '../../Layout/BonusPobjednici.jsx'

export class PokerReloadBody extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: ['Pravila', 'Bodovanje', 'Uvjeti'],
            selectedTab: null,
            aktivanBonus: false,
            dostupanBonus: false,
            bonusPostotak: 0,
            bonusKuna: 0,
            iznosBonusa: 0,
            brojBodova: 0,
            MaxBodova: 0,
            datumZavrsetka: new Date()
        }

        this.gotoTab = this.gotoTab.bind(this);
        this.getBody = this.getBody.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.setData = this.setData.bind(this);
        this.getTime = this.getTime.bind(this);

        this.fetchData();

        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Poker Reload', 'poker', this.props.user);
    }

    fetchData() {
        var promises = Promise.all([casino.repos.promotionRepo.list()]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }

    componentWillUnmount() {
        this.dataPromises.cancel();
    }

    setData(data) {
        var [promotions] = data;

        var newState = {
            dostupanBonus: false,
            aktivanBonus: false
        }

        if (promotions && promotions.availableItems)
            promotions.availableItems.map(x => {
                if (x.poker)
                    newState.dostupanBonus = true;
            });

        if (!newState.dostupanBonus && promotions && promotions.runningItems)
            promotions.runningItems.map(x => {
                if (x.poker) {
                    newState.aktivanBonus = true;
                    newState.bonusPostotak = x.iznosIsplaceno / x.iznos * 100;
                    newState.bonusKuna = x.iznosIsplaceno;
                    newState.iznosBonusa = x.iznos;
                    newState.datumZavrsetka = x.datumZavrsetka;
                    newState.MaxBodova = x.maxBodova;
                    newState.brojBodova = x.brojBodova;
                }
            });

        newState.zadnjiPokerReload = promotions.zadnjiPokerReload;

        this.setState(newState);
    }

    componentDidMount() {
        this.gotoTab(this.state.tabs[0]);
    }
    gotoTab(tab) {
        this.setState({
            selectedTab: tab
        });
    }

    getTime(end, active) {
        var delta = (new Date(end) - new Date()) / 1000;

        if (delta < 0 || !active)
            return "Završeno";

        var dana = Math.floor(delta / 86400);
        delta -= dana * 86400;
        var sati = Math.floor(delta / 3600) % 24;
        delta -= sati * 3600;
        var minute = Math.floor(delta / 60) % 60;
        delta -= minute * 60;
        var sekunde = Math.floor(delta % 60);

        var formatDana = function (i) {
            return i > 1 ? "dana" : "dan";
        }
        var formatSata = function (i) {
            return i > 4 ? "sati" : "sata";
        }

        if (dana > 0)
            return dana + " " + formatDana(dana) + " i " + sati + " " + formatSata(sati);
        else
            return sati + " " + formatSata(sati) + " i " + minute + " minuta";
    }

    getBody() {
        let trajeDo = null;
        if (this.state.zadnjiPokerReload && this.state.zadnjiPokerReload.datumZavrsetka)
            trajeDo = casino.utils.dateToFullDateString(new Date(this.state.zadnjiPokerReload.datumZavrsetka)) + ' u ' + casino.utils.dateToTimeString(new Date(this.state.zadnjiPokerReload.datumZavrsetka));

        return (<div>
            <div className="padding-sides-medium-2">
                <h2 className="v3">{this.state.selectedTab}</h2>
                <div>
                    {this.state.selectedTab == 'Pravila' &&
                        <ul className="list">
                            {/*trajeDo && <li>Reload bonus promocija traje do <b>{trajeDo}</b> </li>*/}
                            <li>Prilikom prijenosa sredstava na Casino/Poker račun, prihvatite Poker reload bonus do <b>100,00%</b> iznosa uplate i zaigrajte online poker na najboljem online casinu u Hrvatskoj.</li>
                            <li>Iznos bonusa jednak je iznosu uplate prilikom aktivacije bonusa. Period prikupljanja bodova na osnovu kojih se osvaja bonus, je <b>{this.state.zadnjiPokerReload && this.state.zadnjiPokerReload.trajanjePromocije} dana</b>, od dana aktivacije promocije.</li>
                            <li>Minimalni iznos uplate kojom možete aktivirati bonus je <b>{(this.state.zadnjiPokerReload && this.state.zadnjiPokerReload.minDeposit)} €</b>, a maksimalni iznos koji možete osvojiti je <b>{(this.state.zadnjiPokerReload && this.state.zadnjiPokerReload.maxDeposit)} €</b>.</li>
                        </ul>}
                    {this.state.selectedTab == 'Bodovanje' &&
                        <ul className="list">
                            <li>Bodovi se osvajaju igranjem Pokera.</li>
                            <li>Sudjelovanjem u online Texas Hold'em pokeru za svakih <b>0,05 € rake-a osvajate 1 bod</b>.</li>
                            <li>Za svakih osvojenih <b>{this.state.zadnjiPokerReload && this.state.zadnjiPokerReload.brojBodova} bodova</b>, „oslobađate“ <b>5 €</b> bonusa.</li>
                            <li>Ukoliko je na kraju bonusa posljednji preostali dio za isplatu manji od <b>5 €</b>, isplatit će se u cijelosti nakon “oslobođenja” posljednjih <b>{this.state.zadnjiPokerReload && this.state.zadnjiPokerReload.brojBodova} bodova</b>.</li>
                        </ul>}
                    {this.state.selectedTab == 'Uvjeti' &&
                        <ul className="list">
                            <li>Prilikom bonusa se primjenjuju standardna pravila i uvjeti korištenja.</li>
                            <li>SuperSport zadržava pravo promijeniti pravila bonusa u bilo kojem trenutku.</li>
                        </ul>}
                </div>
            </div>
        </div>)
    }

    render() {
        return <div>

            {(this.state.aktivanBonus || this.state.dostupanBonus) &&
                <div className="padding-sides-medium-2 " style={{ backgroundColor: '#36414a' }}>

                    <h2 className="v6 ">Moj napredak "Reload bonusa"</h2>

                    <div style={{ height: '35px' }}>
                        {!this.state.aktivanBonus &&
                            <NavLink to={{
                                pathname: this.props.getHomePathFn(this.props.route.location, '/account'),
                                state: { showNaCasino: true }
                            }}  >
                                <div className="text-white " style={{ fontSize: "14px", lineHeight: "35px" }}>

                                    <div style={{ height: "19px", width: "19px", backgroundColor: '#ca242f', display: 'inline-block', position: "relative", top: "4px", marginRight: "4px", borderRadius: "4px" }}>
                                        <span className="icon ico-chevron-right" style={{ float: 'left', fontSize: '16px', marginLeft: '2px', marginTop: '1px' }}></span>
                                    </div>
                                    <div style={{ display: 'inline-block' }}> Potrebna je uplata na casino račun</div>

                                </div>
                            </NavLink>
                        }
                    </div>

                    <div className="progress-bar">
                        <div className="bar">
                            {!this.state.aktivanBonus && <div className="bar--progress" style={{ width: '3%' }} />}
                            {this.state.aktivanBonus && <div className="bar--progress" style={{ width: this.state.bonusPostotak + '%' }} />}
                        </div>
                        {this.state.aktivanBonus && this.state.bonusPostotak <= 60 && <div className={"iznos-desni" + (this.state.bonusPostotak < 0.5 ? ' no-border' : '')} style={{ left: this.state.bonusPostotak + '%' }}>
                            {this.state.bonusPostotak < 30 && <span className="text-18 text">Osvojenih </span>}
                            {this.state.bonusKuna + ' €'}
                        </div>}
                        {this.state.aktivanBonus && this.state.bonusPostotak > 60 && <div className={"iznos-lijevi" + (this.state.bonusPostotak > 99.5 ? ' no-border' : '')} style={{ right: (100 - this.state.bonusPostotak) + '%' }}>
                            {this.state.bonusPostotak > 70 && <span className="text-18 text">Osvojenih</span>}
                            {this.state.bonusKuna + ' €'}
                        </div>}
                    </div>
                    {this.state.aktivanBonus && <div>
                        <div className="text-right" style={{ borderRight: '1px solid rgba(181, 206, 227, .5)', paddingRight: '5px', paddingTop: '1px', marginTop: '4px' }}>
                            <span className="text-right  text-16 text relative" style={{ bottom: '-4px' }}>Maksimalno {this.state.iznosBonusa + ' €'}</span>
                        </div>

                        <div className="text-left text-17 text" style={{ marginBottom: '0px', marginTop: '15px' }}><span className=" text-17 text">Do isteka još: </span><span className="text-white"><span className="semi-bold">{this.getTime(this.state.datumZavrsetka, this.state.aktivanBonus)}</span></span></div>
                        <div className="text-left text-17 text" style={{ paddingBottom: '12px', marginTop: '0px' }}>Prikupljenih bodova: <span className="text-white"><span className="semi-bold">{this.state.brojBodova}</span></span> od {this.state.MaxBodova}
                        </div>
                    </div>}

                    {!this.state.aktivanBonus && <br />}

                    <div className=" break-page tablet-hidden"></div>
                    <div className="mobile-hidden"><br /><br /></div>

                </div>
            }
            <div className="segment v2 margin-top-small padding-sides-medium-2">
                {this.state.tabs && this.state.tabs.map((tab) => <button key={tab} onClick={() => this.gotoTab(tab)} className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}>
                    <span>{tab}</span></button>
                )}
            </div>
            {this.getBody()}

            {this.state.selectedTab != 'Rezultati' &&

                <div className="text-center ">

                    <br />
                    <a className="btn medium fill gray blue margin-top margin-bottom no-text-transform" target="_blank" href={'https://cdn.supersport.hr/Casino/Poker/Pravila/Pravila_Poker_Reload_v3.pdf' + '?c=' + casino.config.guiCacheVerzija}>
                        <span>Provjerite pravila igre</span> <span className="icon ico-expand-outline"></span>
                    </a>
                </div>
            }
        </div>
    }
}